"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconAnalytics = function IconAnalytics(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconAnalytics', className),
    style: style,
    viewBox: "0 0 18 16"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }, _react.default.createElement("rect", {
    width: "3.7",
    height: "5.7",
    x: ".65",
    y: "9.65",
    rx: "1.5"
  }), _react.default.createElement("rect", {
    width: "3.7",
    height: "9.7",
    x: "7.15",
    y: "5.65",
    rx: "1.5"
  }), _react.default.createElement("rect", {
    width: "3.7",
    height: "14.7",
    x: "13.65",
    y: ".65",
    rx: "1.5"
  })));
};

var _default = IconAnalytics;
exports.default = _default;